<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "manger-index",
  data() {
    return {};
  },
  methods: {},
  components: {},
  mounted() {
    let title = "";

    switch (this.$store.state.apptype) {
      case "mst":
        title = "民生通";
        break;
      case "ipy":
        title = "i濮阳";
        break;
      case "ctt":
        title = "丛台通";
        break;
      case "lzt":
        title = "临漳购";
        break;
      case "dxbst":
        title = "东乡百事通";
        break;
    }
    console.log(title);
    let sidebar = [
      { name: "基本设置", router: "adminBasic", isShow: 1 },
      { name: "管理员设置", router: "adminManage", isShow: 1 },
      {
        name: "功能设置",
        children: [
          { name: title, router: "miniProgram" },
          {
            name:
              this.$store.state.apptype == "ctt"
                ? "丛台先锋"
                : this.$store.state.apptype == "dxbst"
                ? "东乡先锋"
                : "先锋e家",
            router: "miniProgram?1",
          },
          { name: "网站", router: "webSetting" },
        ],
        isShow: 1,
        showChild: false,
      },
      // { name: '积分设置', router: 'adminJifen',isShow: false  }
    ];
    this.$store.commit("updateSideList", sidebar);
  },
};
</script>

<style scoped>
</style>
